module.exports = __webpack_public_path__ + "img/slphouse_main5.876e899f.png";